import React, { useCallback, useRef, useEffect, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';

import { IconType } from 'react-icons/lib';

import {
  Container,
  SecondaryContainer,
  ContainerWhite,
  GreyContainer,
  Capa,
  ProgramContainer,
  Sponsors,
  Photo,
} from './styles';

import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useModal } from '../../hooks/Modal';

import { usePages } from '../../hooks/Pages';
import { useLanguage } from '../../hooks/Language';
import SlideList from '../DashboardPages/features/SliderComponent';
import ProjectList from '../DashboardPages/features/ProjectList';
import EventList from '../DashboardPages/features/EventsList';
import api from '../../services/api';
import { hash, urlWebsite } from '../../config';
import { Button } from '../../components/Button/styles';
import SliderContainer from '../../components/SliderContainer';
import { FaBrain, FaSearch, FaStar } from 'react-icons/fa';
import Calendar from './modules/Calendar';
import SelectSimple from '../../components/Forms/SelectSimple';
import EventsListDisplay from '../DashboardPages/features/EventsListDisplay';
import PosterListDisplay from '../DashboardPages/features/PosterListDisplay';
import TestimonialListDisplay from '../DashboardPages/features/TestimonialDisplay';
import { ContactIcons, ContactIconsOrange, scrollTo } from '../../components/Menu';
import themeDefault from '../../styles/ThemeComponents';
import Input from '../../components/Forms/Input';
import SignUp from '../SignUp';
import Youtube from '../../components/Youtube';
import ContagemRegressiva from '../../components/ContagemRegressiva';
import { loadFromJson } from '../../utils/loadFromJson';
import Speakers from '../Speakers';
import Program from '../Program';
import { useConfiguration } from '../../hooks/Configuration';


interface IMenu {
  title: string;
  target: string;
  targetID: string;
  fluid: number;
  external: number;
  status: number;
}

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Conect: React.FC = () => {

  const { setMenu } = usePages();
  const { setAvailableLanguages } = useLanguage();
  const { translate } = useLanguage();
  const { addModal, removeModal } = useModal();
  const [slides, setSlides] = useState<Array<JSX.Element>>([]);
  const { user } = useAuth();
  const { configuration } = useConfiguration();
  const [search, setSearch] = useState('');
  const [currentCategory, setCurrentCategory] = useState('');
  const sendToEvents = () => {

    let link = currentCategory ? `/eventos/${currentCategory}` : `/eventos`;

    if (search) {
      link = `${link}?search=${encodeURIComponent(search)}`;
    }

    window.location.href = link;

  }

  const loadConfig = async () => {
    let data: Record<string, any> = {};

    const item = await loadFromJson({ hash: hash, project_id: 'global', table: 'Global' })


    if (!item) {
      const config = await api.get('/get_platform');

      data = config.data;
    }
    else {
      data = item?.[0] || {}
    }


    if (data.slides) {
      const slideJSX: Array<JSX.Element> = [];

      data.slides.map(s => {
        slideJSX.push(s.link_url ? <a href={s.link_url}><img src={`${urlWebsite}/${s.url}`} style={{ width: '100%' }} /></a> : <img src={`${urlWebsite}/${s.url}`} style={{ width: '100%' }} />)
      })

      setSlides(slideJSX);

      if (data?.popup_status === 'yes' && data?.popup_images && data?.popup_images?.length > 0) {

        if (user && user.updated_information !== 'yes' && user.profile === 2) {

        }
        else {
          addModal({
            key: 'popup',
            theme: 'whiteModalCapa',
            title: ' ',
            content: <><div style={{ width: '100%', maxWidth: '700px', margin: '0px auto' }}>
              <h2 style={{ padding: '10px', width: '100%', textAlign: 'center', color: 'rgb(0,14,64)' }}>Clique na imagem para acessar</h2>
              {data?.popup_images.map(popup => {
                return <a onClick={() => removeModal('popup')} key={`popup-url-${popup.url}`} style={{ width: '100%', maxWidth: '700px', margin: '15px auto' }} href={`${popup?.link_url}`}>
                  <img src={`${urlWebsite}/${popup.url}`} style={{ width: '100%', maxWidth: '700px', margin: '0px auto' }} />
                </a>

              })}

            </div></>
          })

        }


      }

    }

    const menu: Array<IMenu> = [];

    try {
      data?.menu.map((m: IMenu) => {
        m.fluid = parseInt(m.fluid.toString(), 10);
        m.status = parseInt(m.status.toString(), 10);
        m.external = parseInt(m.external.toString(), 10);

        menu.push(m);
      })

      setMenu(menu);

    }
    catch (err) {
      console.log('Error on define Menu');
    }


    setAvailableLanguages(data?.languages || []);




  }

  useEffect(() => {
    loadConfig();
    /*
        addModal({
       key:'popup',
       theme: 'whiteModal2',
       title:' ',
       content: <><div style={{width:'100%', maxWidth:'500px', margin: '0px auto'}}>
         <Link onClick={() => removeModal('popup')} style={{width:'100%', maxWidth:'500px', margin: '0px auto'}} to="/app/sessao-clinica-hospitais-dasa-brasil/login">
           <img src="/apoio/sessao-clinica.png" style={{width:'100%', maxWidth:'500px', margin: '0px auto'}}/>
         </Link>
         </div></>
     }  ) */
  }, [])

  const confirmPresense = (data) => {

  }


  const handle = () => { }

  return (<>
    <Container className='bg1' style={{ minHeight: '80vh' }}  >
      <Capa  >
        <div className=' '>
          <div className='singleLogos'  >
            <img src="/apoio/conect.jpg" style={{ width: '100%', maxWidth: '800px' }} />
          </div>
        </div>
        <div className='p50 homeTitle' style={{ background: '#fff', borderRadius: '15px', padding: '25px', margin: '15px' }}>






          <div className='description' >   <p style={{ color: '#333', textAlign: 'justify', fontSize: '18px' }}>
            O Congresso Escolar-Científico da UFCSPA (CONECt-UFCSPA) é um evento que busca aproximar a escola pública de ensino fundamental e médio da universidade. É um espaço onde alunos e professores desses diferentes universos convergem em uma linguagem comum através da troca de experiências e conhecimentos, em um ambiente repleto de possibilidades de aprendizado, diálogo, reflexão e prática.

            <br /><br /> Dúvidas e informações: congresso@ufcspa.edu.br.
          </p> </div>

          <div style={{ textAlign: 'left', fontSize: '18px', color: '#333', marginTop: '25px' }}>
            <strong style={{ textAlign: 'left', fontSize: '18px', color: '#333', }}> Para submeter um trabalho no 2º CONECt-UFCSPA, faça seu cadastro na plataforma e acesse a aba de submissão de trabalhos.</strong>
            <aside style={{ display: 'flex', gap: '15px', marginTop: '15px', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/app/congresso-2023/inscricao"><button className='defaultButtonReverse'>Quero me inscrever</button></Link>
              <Link to="/app/congresso-2023/login"><button className='defaultButtonReverse'>Submeter Trabalho</button></Link>
              <Link to="/conect" onClick={(e) => { scrollTo(e, 'programacao') }}><button className='defaultButtonReverse'>Programação</button></Link>


            </aside>
            <aside style={{ display: 'flex', gap: '15px', marginTop: '15px', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>

              <a download href="/apoio/2-congresso-escolar-cientifica-da-ufcspa-regulamento.pdf">
                <button className='defaultButtonReverse' style={{ height: 'auto', padding: '15px', marginTop: '0px' }}> REGULAMENTO PARA SUBMISSÃO DE TRABALHOS
                </button>
              </a>
            </aside>
          </div>

        </div>






      </Capa>




    </Container>
    {/* <Container className='bg2  noPadding noMax' style={{ minHeight: 'auto', background: 'rgba(255,255,255,0.95' }}>
      <Capa className=' noPadding noMax' style={{ marginBottom: '25px', }}>


        <div className='p50 homeTitle'>




          <h2  >A conversa sobre saúde no trabalho não pode parar</h2>



          <p className='description'>Em sua terceira edição, o VIII Encontro Internacional de Neonatologia e VI Simpósio Interdisciplinar de Atenção ao Prematuro Saúde 2023 vem aí! O mais completo evento do Brasil acontecerá nos dias <strong>9 e 10 de maio</strong> em formato híbrido.
            <br /><br />


            Este ano, especialistas falarão sobre saúde mental, promoção da saúde, segurança e saúde no trabalho, trazendo <strong>reflexões conectadas ao ESG</strong>, uma das temáticas mais importantes da atualidade.

            <br /><br />

            Promovido pelo Serviço Social da Indústria do RS, o VIII Encontro Internacional de Neonatologia e VI Simpósio Interdisciplinar de Atenção ao Prematuro Saúde prepara <strong>pessoas e empresas</strong> para uma gestão adequada e avançada da <strong>saúde integral no trabalho</strong>, apresentando formas de promover <strong>ambientes laborais saudáveis</strong> em cenários de constantes mudanças.
          </p>
          <div style={{ width: '100%', maxWidth: '612px', display: 'flex', justifyContent: 'flex-start' }}>
            <a href="/app/congresso-2023/inscricao" className="buttonBigBlue"><button>INSCREVA-SE</button></a>
          </div>



        </div>




      </Capa>

        </Container> */}
    <div id="programacao" className='speakersDivContainer noPadding' style={{ width: '100%', background: '#fff', margin: '0px auto' }}>
      <Program filterCategory='2º CONECt UFCSPA' />
    </div>
    {/* <Container className='bg2  noPadding noMax' style={{ minHeight: 'auto' }}>
      <Capa className=' noPadding noMax' style={{ marginBottom: '25px', flexDirection: 'column' }}>

        <div className='speakersDivContainer noPadding' style={{ width: '100%', maxWidth: '1000px', margin: '10px auto' }}>
          <Speakers background={"none"} />
        </div>



      </Capa>

        </Container> */}


  </>
  );
};
export default Conect;
